import React from 'react'

export const LogoRoundUnstyled = props => (
  <img alt="" className={props.className} src={props.logo || ''} />
)
